
export interface PageContents {
    pkid: number;
    name: string;
    title: string;
    subtitle: number;
    version: string;
    pubLastDate: string;
    contents: Array<Content>;
}

export class Content {
    pkid: number;
    page: string;
    name: string;
    title: string;
    subtitle: string;
    type: ContentType;
    text: string;
    pos: number;
    version: string;
}

export interface ContentType {
    pkid: number;
    term: string;
    version: string;
}



// WEBPACK FOOTER //
// ./src/app/models/page-contents.ts